"use client";

import { motion } from "framer-motion";
import { BgLayer, Drift, Star } from "./bg/BgPrimitives";

export default function WhoItsFor() {
  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.13 } },
  };
  const cardVariants = {
    hidden: { opacity: 0, y: 36, scale: 0.97 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] as [number, number, number, number] } },
  };

  return (
    <section id="who" className="bg-[--surface-warm] py-20 px-4 relative overflow-hidden section-grain">
      <BgLayer>
        <Star x={46} y={14} size={26} opacity={0.7}/>
        <Star x={92} y={68} size={20} color="var(--color-foreground)" opacity={0.55}/>
      </BgLayer>
      <div className="container mx-auto relative z-10">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-foreground text-center mb-4"
          initial={{ opacity: 0, y: -18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          Who this is for
        </motion.h2>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 max-w-5xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          <motion.div
            className="bg-muted border border-muted/60 shadow-sm rounded-xl p-8 flex flex-col items-center text-center"
            variants={cardVariants}
            whileHover={{ y: -5, transition: { duration: 0.2 } }}
          >
            <motion.div whileHover={{ rotate: [0, -8, 8, -4, 0], transition: { duration: 0.4 } }}>
              <img src="/icons/JA Full-Color_YOUTH DEVELOPMENT.png" alt="" width={120} height={120} className="mb-4" />
            </motion.div>
            <h3 className="text-lg font-semibold text-foreground mb-2">Youth learners</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              For high school students, university-age youth, and young professionals who want
              practical financial skills for real life.
            </p>
          </motion.div>

          <motion.div
            className="bg-muted border border-muted/60 shadow-sm rounded-xl p-8 flex flex-col items-center text-center"
            variants={cardVariants}
            whileHover={{ y: -5, transition: { duration: 0.2 } }}
          >
            <motion.div whileHover={{ rotate: [0, -8, 8, -4, 0], transition: { duration: 0.4 } }}>
              <img src="/icons/JA Full-Color_TEACHER.png" alt="" width={120} height={120} className="mb-4" />
            </motion.div>
            <h3 className="text-lg font-semibold text-foreground mb-2">Teachers and volunteers</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              For those supporting youth learning and following learner participation and progress
              through the program.
            </p>
          </motion.div>

          <motion.div
            className="bg-muted border border-muted/60 shadow-sm rounded-xl p-8 flex flex-col items-center text-center"
            variants={cardVariants}
            whileHover={{ y: -5, transition: { duration: 0.2 } }}
          >
            <motion.div whileHover={{ rotate: [0, -8, 8, -4, 0], transition: { duration: 0.4 } }}>
              <img src="/icons/JA Full-Color_SCHOOL.png" alt="" width={120} height={120} className="mb-4" />
            </motion.div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Schools, universities, and partners
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              For institutions and organizations looking to offer relevant, practical financial
              literacy learning to the youth they serve.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
